import { logWrapper } from '../../utils';

export default {
  watermarkService: [
    'runtimeConstant',
    '$http',
    '$q',
    function (runtimeConstant, $http, $q) {
      function generateWatermark(id, idCompany, extension, userName, setor) {
        var deferred = $q.defer();

        var server = 'PROD';
        var webApiMethod = 'https://viewer.digitaldoc.com.br/watermark';

        var revisionTemp = {
          id: id,
          idCompany: idCompany,
          Extension: extension,
          Server: server,
          User: userName,
          Setor: setor,
        };

        $http
          .post(webApiMethod, revisionTemp, {
            responseType: 'arraybuffer',
          })
          .then(
            function (result) {
              deferred.resolve(result);
            },
            function (err) {
              deferred.reject(err);
            }
          );

        return deferred.promise;
      }

      function run() {
        try {
          var watermarkServiceFactory = {};

          watermarkServiceFactory.generateWatermark = logWrapper(
            generateWatermark,
            runtimeConstant.isDebugServicesInternals
          );

          return watermarkServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
